export default ({
  addLabel,
  allowEmpty,
  basePath,
  cellClassName,
  className,
  formClassName,
  headerClassName,
  label,
  linkType,
  locale,
  record,
  resource,
  sortable,
  sortBy,
  source,
  target,
  textAlign,
  translateChoice,
  ...rest
}) => rest;



// WEBPACK FOOTER //
// ./src/components/sanitizeRestProps.js